import { render, staticRenderFns } from "./BarHeading.vue?vue&type=template&id=053f6d09&scoped=true&"
import script from "./BarHeading.vue?vue&type=script&lang=js&"
export * from "./BarHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053f6d09",
  null
  
)

export default component.exports